class FeedingCalculator {
  constructor() {
    // No need for activity multipliers with the new logic
  }

  getAgeCategory(ageYears) {
    if (ageYears < 1) {
      return 'puppy';
    } else if (ageYears >= 7) {
      return 'senior';
    } else {
      return 'adult';
    }
  }

  getPuppyRange(ageYears) {
    if (ageYears < 0.25) {
      return '0-3';
    } else if (ageYears < 0.5) {
      return '3-6';
    } else if (ageYears < 0.75) {
      return '6-9';
    } else {
      return '9-12';
    }
  }

  calculateNaturawFeeding(weightKg, ageCategory, puppyRange = null) {
    let dailyKg = 0;

    if (ageCategory === 'puppy') {
      switch (puppyRange) {
        case '0-3':
          dailyKg = weightKg * 0.08;
          break;
        case '3-6':
          dailyKg = weightKg * 0.06;
          break;
        case '6-9':
          dailyKg = weightKg * 0.04;
          break;
        case '9-12':
          dailyKg = weightKg * 0.03;
          break;
        default:
          dailyKg = weightKg * 0.04; // fallback
      }
    } else if (ageCategory === 'adult') {
      dailyKg = weightKg * 0.025;
    } else if (ageCategory === 'senior') {
      dailyKg = weightKg * 0.02;
    } else {
      throw new Error('Invalid age category');
    }

    const dailyGrams = Math.round(dailyKg * 1000);
    const weeklyKg = +(dailyKg * 7).toFixed(2);
    const monthlyKg = +(dailyKg * 30).toFixed(2);

    return {
      perDay: `${dailyGrams}g`,
      perWeek: `${weeklyKg}kg`,
      perMonth: `${monthlyKg}kg`
    };
  }

  calculateFeedingAmounts(weightKg, ageYears, activityLevel = 'moderate') {
    const ageCategory = this.getAgeCategory(ageYears);
    const puppyRange = ageCategory === 'puppy' ? this.getPuppyRange(ageYears) : null;
    
    const feeding = this.calculateNaturawFeeding(weightKg, ageCategory, puppyRange);
    
    // Extract numeric values for compatibility with existing code
    const dailyGrams = Math.round(parseFloat(feeding.perDay.replace('g', '')));
    const weeklyKg = parseFloat(feeding.perWeek.replace('kg', ''));
    const monthlyKg = parseFloat(feeding.perMonth.replace('kg', ''));
    
    return {
      daily_grams: dailyGrams,
      weekly_kg: weeklyKg,
      monthly_kg: monthlyKg,
      age_category: ageCategory,
      puppy_range: puppyRange,
      // Keep formatted strings for display
      perDay: feeding.perDay,
      perWeek: feeding.perWeek,
      perMonth: feeding.perMonth
    };
  }

  static validateInputs(weightKg, ageYears, activityLevel) {
    const errors = {};

    if (!weightKg || weightKg <= 0) {
      errors.weight = 'Weight must be greater than 0';
    } else if (weightKg > 100) {
      errors.weight = 'Weight seems unusually high - please check';
    }

    if (!ageYears || ageYears < 0) {
      errors.age = 'Age must be greater than or equal to 0';
    } else if (ageYears > 25) {
      errors.age = 'Age seems unusually high - please check';
    }

    if (!activityLevel || !['low', 'moderate', 'high', 'very_high'].includes(activityLevel)) {
      errors.activity = 'Please select a valid activity level';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
}

// Export for both browser and Node.js environments
if (typeof window !== 'undefined') {
  window.FeedingCalculator = FeedingCalculator;
}
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FeedingCalculator;
} 